import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';

const Image = (props) => {
  const {
    src,
    srcDark,
    offset,
    height,
    addClass,
    addClassDark,
    width,
    alt,
    useLazyLoad,
    onClick,
    style,
  } = props;

  let activeSrc = src;
  let activeClass = addClass;

  const handleBrokenImage = (e) => {
    if (props.handleBrokenImage) {
      e.target.src = props.handleBrokenImage;
    }
  };

  if (srcDark && addClassDark) {
    activeSrc = srcDark ? srcDark : src;
    activeClass = addClassDark ? addClassDark : addClass;
  }

  if (useLazyLoad) {
    return (
      <LazyLoad height={height} once offset={offset}>
        <img
          onError={handleBrokenImage}
          className={activeClass}
          src={activeSrc}
          width={width}
          height={height}
          alt={alt}
          onClick={onClick}
          style={style}
        />
      </LazyLoad>
    );
  } else {
    return (
      <img
        onError={handleBrokenImage}
        className={activeClass}
        src={activeSrc}
        width={width}
        height={height}
        alt={alt}
        onClick={onClick}
      />
    );
  }
};

Image.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  alt: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  srcDark: PropTypes.string,
  addClass: PropTypes.string,
  addClassDark: PropTypes.string,
  offset: PropTypes.number,
  handleBrokenImage: PropTypes.string,
  onClick: PropTypes.func,
  useLazyLoad: PropTypes.bool, // prop to determine if we want to use lazyload on image or not, by default it is true
};

Image.defaultProps = {
  offset: 100,
  addClass: '',
  handleBrokenImage: null,
  useLazyLoad: true,
  onClick: () => {},
};

export default Image;
